/* eslint-disable @next/next/no-img-element */
import { Highlight } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { HitProps } from './_types';
import { ProductHitHeadline } from './_ProductHitHeading';
import useDictionary from 'lib/sitecore/use-dictionary';
import { EcommerceDataLayerObject, gtmEcommerceDatalayerPush } from 'lib/util/gtm-datalayer';

export const ProductListHit = ({ hit }: HitProps) => {
  const dictionary = useDictionary();
  const pushGtm = () => {
    const gtmData: EcommerceDataLayerObject = {
      event: 'select_item',
      ecommerce: {
        value: '0',
        currency: 'USD',
        items: [
          {
            item_id: hit.itemNumber ?? hit.objectID,
            item_name: hit.pageTitle,
            affiliation: 'N/A',
            coupon: 'N/A',
            discount: 'N/A',
            index: 'N/A',
            item_brand: 'NMDP',
            item_category: hit?.mediaType?.toString(),
            item_category2: hit?.patientResources?.toString(),
            item_category3: hit?.productLanguages?.toString(),
            item_category4: hit?.resourceType?.toString(),
            item_list_name: 'order_materials',
            item_variant: 'N/A',
            price: 0,
            quantity: 1,
          },
        ],
      },
    };
    gtmEcommerceDatalayerPush(gtmData);
  };
  return (
    <div>
      <div className={classnames('rounded-lg', 'border-solid', 'border', 'border-gray-midGray')}>
        <img alt="product" src={hit.productImage} className={classnames('rounded-lg')} />
      </div>
      <ProductHitHeadline hit={hit}>
        <Highlight hit={hit} attribute="pageTitle" onClick={pushGtm} />
      </ProductHitHeadline>
      {hit.itemNumber && (
        <p className={classnames('inline', 'text-sm')}>
          {dictionary.ProductDetails_ItemNumber} {hit.itemNumber}
        </p>
      )}
    </div>
  );
};
